import { useLanguage } from "@/context/LanguageContext";
import { usePageTitle } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";

export default function Legal({ type }) {
  const { t } = useLanguage();
  usePageTitle(t.meta[type]);
  const content = t.legal[type];

  return (
    <div data-testid={`legal-${type}-page`} className="pt-24">
      <section className="mx-auto max-w-3xl px-6 pb-24 pt-16 md:pt-24">
        <Reveal>
          <h1 className="font-serif text-4xl leading-tight tracking-tight text-ink md:text-5xl lg:text-6xl">
            {content.title}
          </h1>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-stone/60">{content.updated}</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {content.sections.map((s, i) => (
            <Reveal key={i} delay={0.03}>
              <div className="border-t border-line pt-8">
                <h2 className="font-serif text-2xl text-ink md:text-3xl">{s.h}</h2>
                <p className="mt-4 text-base leading-relaxed text-stone">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTASection />
    </div>
  );
}
